/**
 * Created by liwenjun on 2017/7/3.
 */

// 直接使用 FileHelperClass
function uploader(file) {
    var thiz = this;
    this.onProcess = function (evt) {};
    //状态码、下载链接、响应详细（包含前两个数据）
    this.onFinish = function (code,dlink,resp) {};
    this.onSuccess = function (dlink,resp) {};
    this.onRedirect = function (resp) {
        handlePost301(resp.data);
    };
    this.onError = function (code,resp) {
        layer.msg("文件上传失败，错误信息：" + resp);
        console.log("文件上传失败，错误信息：" + resp);
    };
    this.start = function(){
        var url = this.getFileUploadAddr();
        // token不适用的时候，直接执行_upload会报错：【无法捕抓】
        //Failed to load resource: net::ERR_CONTENT_LENGTH_MISMATCH 或  POST http://fs.dev.gdy.io/usr/api/uload?pub=1 net::ERR_CONTENT_L

        //解决办法是先验证token，保证token没问题，get请求同一个地址，只要不返回301，就说明token没问题，才可以开始上传
        mustVaildToken(url,function(){
            _upload(url);
        });
    };

    //使用方式支持：new uploader().getFileUploadAddr()
    this.getFileUploadAddr = function(){
        var fileHost = DSSX.host.protocol + '//' + DSSX.host.fs;
        // fileHost = "//" + fileHost.replace("dssxs", "fs");
        var token = new TokenHelper("").getToken();
        return fileHost + "/usr/api/uload?pub=1&token="+token;
    };
    function _upload(url){
        if(file.size > 5*1024*1024){
            layer.msg(file.name + "  文件大小超过5M");
            return ;
        }
        if(file.size == 0){
            layer.msg("不能上传空文件");
            return ;
        }
        var form = new FormData();
        form.append("file", file);
        var xhr = new XMLHttpRequest();
        xhr.open("post", url, true);
        xhr.onload = function () {
            var resp;
            var respType = typeof(this.response);
            if(respType == "object"){
                resp = this.response;
            }else if(respType == "string"){
                // ie 下即使设置responseType，返回的依然是字符串，以下进行转换
                resp = JSON.parse(this.response);
            }else{
                layer.msg("服务器响应数据：" + this.response);
                console.log("服务器响应数据：" + this.response);
                return
            }
            thiz.onFinish(resp.code,resp.data,resp);
            switch (resp.code){
                case 0:
                    thiz.onSuccess(resp.data,resp);
                    return ;
                case 301:
                    thiz.onRedirect(resp);
                    return ;
                default:
                    thiz.onError(resp.code,resp);
            }
        };
        xhr.responseType="json";
        xhr.upload.addEventListener("progress", thiz.onProcess, false);
        xhr.send(form);
    }
}